// extracted by mini-css-extract-plugin
export var errorsContainer = "_ts-1";
export var link = "_ts-0";